import { useQuery } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';

export function useBanksQuery() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<Record<'templates', Bank[]>>({
    queryKey: ['banks'],
    queryFn: async () => {
      try {
        return await fetchData('/client/banks');
      } catch (e) {
        error('[useBanksQuery][GET /client/banks]', e);

        if (e instanceof Error) {
          showError(e);
        }

        throw e;
      }
    },
    staleTime: Infinity,
  });
}

export type Bank = {
  receiver: string;
  bankName: string;
  accountNumber: string;
  clientIdentificationNumber: string;
  masterAccount: boolean;
  bic: string;
  branchPageUrl: string;
  clientPersonalId: string;
  homePageUrl: string;
  registrationNumber: string;
  shortName: string;
};
